import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['makes', 'models'];
  static values = { list: Array };

  loadModels() {
    const makeId = this.makesTarget.value;
    const selectedModelId = this.modelsTarget.dataset.selected;
    const models = this.models;

    const filteredModels = models.filter(model => model.make_id === parseInt(makeId));

    const placeholderOption = this.modelsTarget.querySelector('option[value=""]') || {};
    const placeholder = `<option value="">${placeholderOption.text}</option>`;

    const options = filteredModels.map(model => {
      return `<option value="${model.id}" ${model.id === parseInt(selectedModelId) ? 'selected' : ''}>${model.model}</option>`;
    });

    this.modelsTarget.innerHTML = [placeholder].concat(options);
  }

  get models() {
    return JSON.parse(this.element.dataset.makesAndModelsListValue || '[]');
  }
}
